<template>
  <div>
    <loading :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      :color="color"
      :loader="loader">
    </loading>
    <h3 class="page-header">7-Eleven</h3>
    <div class="report-wrapper">
      <div class="row report-inputs">
        <div ref='partner_select' class="col-md-3">
          <multiselect
            v-model="np_selected"
            :options="nationalPartners"
            :multiple="true"
            pen-direction="bottom"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Choose National Partner(s)"
            label="NAME"
            track-by="CODE"
            select-label="Click to select"
            deselect-label="Click to remove"
            :preselect-first="false"
            :taggable="true"
            @close="getRestaurants()">
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="np_selected.length" @mousedown.prevent.stop="clearAllNP()">❌</div>
            </template>
          </multiselect>
          <label class="form_error" v-show="isNPInvalid">Must select at least one value</label>
        </div>
        <div ref='selected' class="col-md-3">
          <multiselect
            v-model="selected"
            :options="restaurants"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :searchable="true"
            :allow-empty="true"
            :preserve-search="true"
            placeholder="Choose Restaurant(s)"
            label="storeDisplay"
            track-by="externalId"
            select-label="Click to select"
            deselect-label="Click to remove"
            :preselect-first="false">
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="selected.length" @mousedown.prevent.stop="clearAllRestos()">❌</div>
            </template>
          </multiselect>
          <label class="form_error" v-show="isRestInvalid">Must select at least one value</label>
        </div>
        <div class="col-md-2">
          <datepicker v-model="start_date" placeholder="Start Date"></datepicker>
        </div>
        <div class="col-md-2">
          <datepicker v-model="end_date" placeholder="End Date"></datepicker>
        </div>
        <div class="col-md-2">
          <button id="btn" class="btn btn-primary btn-fill" :disabled="btnDissabled == 1" v-on:click="getCustom">Generate Report</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="downloads" ref="downloads" v-if="seen">
              <button v-on:click="exportTableToCSV('RDSLogic_report.csv')" class="btn btn-default"><i class="ti-layout"></i> CSV</button>
            </div>
            <div v-if="table.title" class="header">
              <slot name="header">
                <h4 class="title">{{table.title}}</h4>
              </slot>
            </div>
            <div v-if="seen" class="content table-responsive table-full-width">
              <table class="table table-hover">
              <thead>
                <tr>
                  <th v-for="column in table.columns">{{column}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="order in table.data">
                  <tr v-for="(item, key, index) in order">
                    <td v-if="item.order_type">{{item.order_type}}</td>
                    <td v-else>Total - {{item.total_orders}}</td>
                    <td>{{item.external_store_id}}</td>
                    <td>{{item.orderplaced_timestamp}}</td>
                    <td>{{item.orderplaced_timestamp_utc}}</td>
                    <td>{{item.internal_restaurant_id}}</td>
                    <td>{{item.send_id}}</td>
                    <td>{{item.order_id}}</td>
                    <td>{{item.order_status}}</td>
                    <td>{{item.restaurant_subtotal | currency}}</td>
                    <td>{{item.restaurant_tax | currency}}</td>
                    <td>{{item.bottle_fee | currency}}</td>
                    <td>{{item.dl_commission | currency}}</td>
                    <td>{{item.marketing_fees | currency}}</td>
                    <td>{{item.credit}}</td>
                    <td>{{item.debit}}</td>
                    <td>{{item.transfer_id}}</td>
                    <td>{{item.wire_date}}</td>
                    <td>{{item.linked_fee_amount}}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import {API} from 'src/api'
  import moment from 'moment'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  if(localStorage.userInfo) {
    var userInfo = JSON.parse(localStorage.userInfo)
  }
  export default {
    components: {
      Loading
    },
    data () {
      return {
        start_date: moment().subtract(1, 'days').toString(),
        end_date: moment().toString(),
        table: {
          title: 'Please select your criteria above.',
          columns: [],
          data: [],
          extid: []
        },
        seen: false,
        np_hidden: false,
        np_selected: [],
        selected: [],
        nationalPartners: [],
        restaurants: [],
        isLoading: false,
        fullPage: true,
        height: 128,
        width: 128,
        color: '#0647A6',
        loader: 'bars'
      }
    },
    computed: {
      isNPInvalid () {
        if(this.np_selected.length === 0)
          return true
      },
      isRestInvalid () {
        if(this.selected.length === 0)
          return true
      },
      btnDissabled () {
        if(this.np_hidden) {
          if(this.selected.length === 0) {
            return true
          } else {
            return false
          }
        } else {
          if(this.selected.length === 0 || this.np_selected.length === 0) {
            return true
          } else {
            return false
          }
        }
      }
    },
    methods: {
      getCustom () {
        this.isLoading = true
        var startDate = moment(String(this.start_date)).format('YYYY-MM-DDTHH:mm:ss')
        var endDate = moment(String(this.end_date)).format('YYYY-MM-DDTHH:mm:ss')
        var self = this
        var company = []
        var extid = []
        self.table.title = ''
        self.table.columns = ''
        self.table.data = ''
        self.seen = false

        if (this.selected.length > 0) {
          if(this.selected[0].externalId === 'selectAll' ) {
            for (let rest of Object.values(this.restaurants)) {
              if(rest.externalId !== 'selectAll') extid.push(rest.EXTIDs)
            }
          } else {
            for (let rest_sel of Object.values(this.selected)) {
              extid.push(rest_sel.EXTIDs)
            }
          }
        }
        if(userInfo.company == 'Support') {
          for (let np_sel of Object.values(this.np_selected)) {
            company.push(np_sel.CODE)
          }
        } else {
          company = userInfo.company
        }

        API.post('/report/custom', {
          np: company,
          extid: extid,
          interval: startDate + '/' + endDate
        })
        .then(function (response) {
          console.log('getCustom', response)
          if (response.data.status === 200) {
            self.table.title = ''
            self.table.columns = ['Transaction Type', 'Store ID', 'Local Timestamp', 'UTC Date', 'Internal RID', 'External OID', 'Internal OID', 'Final Status', 'Subtotal', 'Tax', 'Bottle Fee', 'Commission', 'Marketing Fees', 'Credit', 'Debit', 'Transfer ID', 'Wire Date', 'Linked Item Fee']
            self.table.data = response.data.rv
            self.seen = true
            self.isLoading = false
          } else {
            self.table.title = response.data.message
            self.table.columns = ''
            self.table.data = ''
            self.seen = false
            self.isLoading = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getRestaurants () {
        var self = this
        var company = []
        self.restaurants = []
        self.selected = []
        if(userInfo.company == 'Support') {
          //if (this.np_selected.length > 0) {
            for (let np_sel of Object.values(this.np_selected)) {
              company.push(np_sel.CODE)
            }
          // } else {
          //   extid = userInfo.extid
          // }
          // company = this.np_selected
        } else {
          company = userInfo.company
        }
        self.restaurants = [{ externalId: 'selectAll', storeDisplay: 'All Restaurants' }]
        API.get('/restaurant/NP?np=' + company + '&role=' + userInfo.role + '&uid=' + userInfo.uid)
        .then(function (response) {
          if(response.data.entities) {
            for (let rest of Object.values(response.data.entities)) {
              self.restaurants.push(rest)
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getNationalPartners () {
        var self = this
        API.get('/report/partners?np=' + userInfo.company)
        .then(function (response) {
          for (let np of Object.values(response.data.rv)) {
            self.nationalPartners.push(np)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      clearAllNP () {
        this.np_selected = []
      },
      clearAllRestos () {
        this.selected = []
      }
    },
    mounted () {
      if(userInfo.company == 'Support') {
        this.getNationalPartners()
      }
      if(userInfo.company != 'Support') {
        this.getRestaurants()
        this.$refs.partner_select.hidden = true
        this.np_hidden = true
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
th {
  padding-bottom: 10px !important;
}
#btn {
  width: 100%;
}
table>tbody>tr:last-child {
  font-weight: 600;
  background: #e3e3e3;
}
/* .multiselect__content-wrapper {
  max-height: 1000px !important;
  height: 1000px !important;
} */
.card .table tbody td:last-child, .card .table thead th:last-child {
  max-width: 100px;
}
.card .content {
  margin-top: 35px;
}
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// Seven11.vue?1e138e6f